module.exports = __webpack_public_path__ + "3956ef68a1b87b25b9fe8d190b50349d.svg";